
/**
 * @fileOverview ToggleController Module File - this file is used to bind the show / hide event for a piece of content.
 *
 * @author jmaki
 * @version 1.0
 * @last modified: 12/21/18
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/ResponsiveAccordion',['require','jquery','lib/Util','GlobalEventDispatcher','GlobalResizeListener'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');
        var GlobalResizeListener = require('GlobalResizeListener');

        /**
         * @name ResponsiveAccordion
         * @class ResponsiveAccordion Toggles content on a page
         * @param selector {Object} Object containing configuration options and default overrides
         * @constructor
         */
        var ResponsiveAccordion = function (options) {
            this.$triggers = $(options.selector);
            if($('.js-contentToggle-trigger_related_container').length === 0 && options.selector === '.js-contentToggle-trigger_related' && this.$triggers.length > this.$triggers.eq(0).parent().parent().parent().parent().find(options.selector).length){
                var count = this.$triggers.length, eles = this.$triggers, parentCount = 1;

                for(var i=0; i<count; i++){
                    var parent = eles.eq(i).parent().parent().parent().parent().addClass('js-contentToggle-trigger_related_container').addClass('js-append' + parentCount);
                    parentCount = parentCount + 1
                     i = i + parent.find(options.selector).length - 1
                }
                $('.js-contentToggle-trigger_related_container').each(function(i, e){
                    $(e).find('.js-contentToggle-trigger_related').each(function(i2, e2){
                        $(e2).attr('eleParent', '.js-append' + (i+1));
                    });
                });
                $('.js-contentToggle-trigger_related_container').each(function(i, e){
                    new ResponsiveAccordion({selector: '.js-append' + (i+1) + ' .js-contentToggle-trigger_related', hasDefaultState: true, jumpsToTop: false, application: this});
                });
                return false;
            }
            if($('.js-contentToggle-trigger_related_container').length > 0 && $(this.$triggers.attr('href')).length > 1){
                var parentElement = options.selector.split(' ')[0];
            }
            this.$targets = $([]);
            this.accordionPos ='';
            this.accordionHt ='';
            this.isTwisty = options.isTwisty || false;                      //To be used if we want 'twisty' behavior instead of accordion behavior
            this.alwaysActive = options.alwaysActive || false;              //if set to false, the functionality is only available in the small context
            this.hasDefaultState = options.hasDefaultState || false;
            this.jumpsToTop = options.jumpsToTop;
            this.app = options.application;                                //application
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event, provided by the application
            this.globalResizeListener = GlobalResizeListener.getResizeListener();

            if (this.$triggers.first().attr('class') && this.$triggers.first().hasClass('js-contentToggle-trigger_largeAccordion')) {
                this.accordionPos = this.$triggers.first().parent().offset().top;
                this.accordionHt = this.$triggers.first().parent().height();
            }

            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         *
         * @returns {ResponsiveAccordion}
         * @since 1.0
         */
        ResponsiveAccordion.prototype.init = function () {
            this.isEnabled = false;
            $debug('ResponsiveAccordion.js loaded/enabled', 'responsiveAccordion');
            return this.createChildren()
                .setDefaultMiniHeight()
                .setupHandlers()
                .enable();
        };
        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @returns {ResponsiveAccordion}
         * @since 1.0
         */
        ResponsiveAccordion.prototype.setupHandlers = function () {
            var self = this;
            /*
            this.$triggers.on('click', function (event) {
                self.triggerEvent(this,i, event);
            });
            */
            this.$triggers.each(function(i,el) {
                $(el).on('click', function(event) {
                    $debug('event +++++' + $(event.currentTarget).attr('href'), 'responsiveAccordion');
                    self.triggerEvent($(this),i, event);
                });
            });


            /**
             * we need to reset the state of the content drawers and triggers when we switch to mobile and we need to
             * ensure that at least one tab is open when we switch back to desktop, if one is not we open it
             */
            if (this.hasDefaultState) {
                this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE, this.checkOpenState.bind(this));
            }

            return this;
        };

        /**
         * Check to see if at least one accordion or tab is open
         *
         * @return {*}
         */
        ResponsiveAccordion.prototype.checkOpenState = function () {
            var currentContext = this.globalResizeListener.getCurrentContext();
            var $activeTab = this.$targets.filter('.MMM--isActive');
            var activeIndex = this.$targets.filter('.MMM--isActive').index();

            if (currentContext !== 'smallContext' && activeIndex === -1) {
                this.setDefaultState();
            } else if (activeIndex > -1) {
                var id = $activeTab.attr('id');
                this.$triggers.filter('[href=#' + id + ']').addClass('MMM--isActive');
            }
            return this;
        };


        /**
         * This checks to see if there is an active tab, if not, it will make the first tab active.
         */
        ResponsiveAccordion.prototype.setDefaultState = function () {
            this.$triggers.eq(0).trigger('click');
            return this;
        };

        /**
         *
         * @param trigger {Element} the DOM element that you want to process
         * @return {*}
         */
        ResponsiveAccordion.prototype.triggerEvent = function (trigger, num, event) {
            if (this.isEnabled === false) {
                return;
            }
            //needed for IE Support
            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }

            var self = this;

            var $trigger = $(trigger); // The trigger element
            var triggerPos = Math.round($(trigger).offset().top);
                var targetDiv = $trigger.attr('href'); //used to find other triggers
                var $triggerSiblings = $('a[href=' + targetDiv + ']');
                if(!!$trigger.attr("eleParent")){
                        $triggerSiblings = $($trigger.attr('eleParent') +' '+ 'a[href=' + targetDiv + ']');
                        targetDiv = $trigger.attr('eleParent') +' '+$trigger.attr('href'); //used to find other triggers
                }
            var $target = $(targetDiv);  //the target
            var context = this.globalResizeListener.getCurrentContext(); //the current context of the app

            $debug('==== checking targetDiv' + targetDiv + ' and $trigger is ' + $trigger.attr('href'), 'responsiveAccordion');

            //if the context is small or if the triggers are flagged as static , and the target has an active class close it
            if ((context === 'smallContext' && $target.hasClass('MMM--isActive')) || (this.alwaysActive === true && $target.hasClass('MMM--isActive') && targetDiv === $(event.currentTarget).attr('href'))) {
                $debug('context is ' + context, 'responsiveAccordion');
                $debug('option 1', 'responsiveAccordion');
                $debug('***** trigger siblings ' + $triggerSiblings.attr('class'), 'responsiveAccordion');
                $triggerSiblings.removeClass('MMM--isActive');
                $triggerSiblings.attr('aria-expanded','false');  // update the aria-expanded property
                $target.stop().slideUp(250, function () {
                    $(this).removeClass('MMM--isActive').attr('style', '');
                    //self.toggleTarget($trigger, $target, num);
                    if (self.isTwisty === false) {
                        $debug('isTwisty === false', 'responsiveAccordion');
                        self.resetSiblings($trigger, $target, event);

                    }
					
					// If the target contains an inline video or rG-63 player, we need to pause it
					if(typeof videoMods !== 'undefined') {
						$debug('Found inline video module array...', 'responsiveAccordion');
						
						for(var i=0, l=videoMods.length; i<l; i++) {
							$debug('Checking to see if video with video ID "' + videoMods[i].videoID + '" is contained in responsive accordion target...', 'responsiveAccordion');
							
							if($.contains($target[0], videoMods[i].$parentComponent[0])) {
								$debug('Responsive accordion target does contain inline video player video ID "' + videoMods[i].videoID + '", unloading player...', 'responsiveAccordion');
								
								videoMods[i].unloadPlayer();
							}
						}
					}
					
                });
            } else if (context === 'smallContext' || this.alwaysActive === true ) {
                $debug('option 2', 'responsiveAccordion');
                $triggerSiblings.addClass('MMM--isActive');
                $triggerSiblings.attr('aria-expanded','true');  // update the aria-expanded property
                $target.stop().slideDown(250, function () {
                    if (self.isTwisty === false) {
                        $(this).addClass('MMM--isActive').attr('style', '');
                        self.toggleTarget($trigger, $target, num);
                    } else {
                        self.toggleTarget($trigger, $target, num);
                    }
                });
            } else {
                $debug('option 3', 'responsiveAccordion');
                $triggerSiblings.addClass('MMM--isActive');
                $target.addClass('MMM--isActive');
                self.toggleTarget($trigger, $target, num);
            }

            $debug('number = ' + num, 'responsiveAccordion');
            
            this.eventDispatcher.publish('Container State Change'); // Publish event for other modules to fire resize methods if needed

            return this;
        };

        ResponsiveAccordion.prototype.checkOpens = function () {
            var actives = $('.js-rC-53-accordion-header.MMM--isActive');
            var notactives = $('.js-rC-53-accordion-header:not(".MMM--isActive")');
            actives.attr('aria-expanded','true');
            notactives.attr('aria-expanded','false');
        };

        /**
         *
         * @param $trigger {jQuery} the trigger who's siblings you want to reset
         * @param $target {jQuery} the target who's siblings you want to reset
         */
        ResponsiveAccordion.prototype.resetSiblings = function ($trigger, $target, event) {

            $debug('$trigger and $target ' + $trigger.attr('href') + ' ' + $target.attr('href'), 'responsiveAccordion');
            //var targetParent = $target.parent();
            //targetParent.siblings().children('.MMM--isActive').removeClass('MMM--isActive');

            // storing the main parent div for the DPL
            var targetParent = $target.parent().parent().parent();

            //checking for the rC-51-Tabs only
            if ($(targetParent).hasClass('rC-51-Tabs')){

                $debug('found targetParent class === '+ targetParent.attr('class'), 'responsiveAccordion');

                //checking for twisties trigger in Mobile
                targetParent.find('.MMM--tabContentList').children('.MMM--isOnMobile.js-contentToggle-trigger').not($trigger).removeClass('MMM--isActive');

                //checking for twisties target in Mobile
                targetParent.find('.MMM--tabContentList').children('.MMM--tabContent--onMobile.js-contentToggle-target').not($target).each(function(){
					// If the target contains an inline video player, we need to pause it
					if(typeof videoMods !== 'undefined') {
						$debug('Found inline video module array...', 'responsiveAccordion');
						
						for(var i=0, l=videoMods.length; i<l; i++) {
							$debug('Checking to see if video with video ID "' + videoMods[i].videoID + '" is contained in responsive accordion target...', 'responsiveAccordion');
							
							if($.contains($(this)[0], videoMods[i].$parentComponent[0])) {
								$debug('Responsive accordion target does contain inline video player video ID "' + videoMods[i].videoID + '", unloading player...', 'responsiveAccordion');
								
								videoMods[i].unloadPlayer();
							}
						}
					}
					
					$(this).removeClass('MMM--isActive');
				});

                //checking for tabs trigger in Desktop
                targetParent.find('.MMM--tabContentTriggerList').children('.js-contentToggle-trigger').not($trigger).removeClass('MMM--isActive');

                //checking for tabs target in Desktop
                targetParent.find('.MMM--tabContentList').children('.js-contentToggle-target').not($target).each(function(){
					// If the target contains an inline video player, we need to pause it
					if(typeof videoMods !== 'undefined') {
						$debug('Found inline video module array...', 'responsiveAccordion');
						
						for(var i=0, l=videoMods.length; i<l; i++) {
							$debug('Checking to see if video with video ID "' + videoMods[i].videoID + '" is contained in responsive accordion target...', 'responsiveAccordion');
							
							if($.contains($(this)[0], videoMods[i].$parentComponent[0])) {
								$debug('Responsive accordion target does contain inline video player video ID "' + videoMods[i].videoID + '", unloading player...', 'responsiveAccordion');
								
								videoMods[i].unloadPlayer();
							}
						}
					}
					
					$(this).removeClass('MMM--isActive');
				});


            } else {
                // else remove the active classes older way
                this.$triggers.not($trigger).removeClass('MMM--isActive');
                this.checkOpens();  
                this.$targets.not($target).each(function(){
					// If the target contains an inline video player, we need to pause it
					if(typeof videoMods !== 'undefined') {
						$debug('Found inline video module array...', 'responsiveAccordion');
						
						for(var i=0, l=videoMods.length; i<l; i++) {
							$debug('Checking to see if video with video ID "' + videoMods[i].videoID + '" is contained in responsive accordion target...', 'responsiveAccordion');
							
							if($.contains($(this)[0], videoMods[i].$parentComponent[0])) {
								$debug('Responsive accordion target does contain inline video player video ID "' + videoMods[i].videoID + '", unloading player...', 'responsiveAccordion');
								
								videoMods[i].unloadPlayer();
							}
						}
					}
					
					$(this).removeClass('MMM--isActive');
				});
            }
        };

        /**
         * This is used to reset the targets and triggers when a new one is selected.
         * Toggles the selected target if in the small context, else
         * @param $target
         */
        ResponsiveAccordion.prototype.toggleTarget = function ($trigger, $target, triggerNum) {
            var context = this.globalResizeListener.getCurrentContext();
            var self = this;
            var triggerOffset = $trigger.outerHeight();

            $debug('in toggle target', 'responsiveAccordion');

            if (self.isTwisty === false) {
                $debug('isTwisty === false', 'responsiveAccordion');
                self.resetSiblings($trigger, $target);
            }

            if (context === 'smallContext' && $target.hasClass('MMM--isActive')) {
                $debug('mobile slide up', 'responsiveAccordion');
                var jumpToPos = $trigger.offset().top - (triggerOffset * 2);

                //mobile and already active --- slide up
                if (!(self.isTwisty === false)) {
                    $target.slideUp(250, function () {
                        $(this).removeClass('MMM--isActive').attr('style', '');
                        if (self.jumpsToTop) {
                            //check this for accuracy
                            $debug('jumps to top', 'responsiveAccordion');
                            $('html, body').scrollTop($target.offset().top - (triggerOffset * 2));
                        }
                    });
                }
                else {
                    if (self.jumpsToTop) {
                        //check this for accuracy
                        $debug('jumps to top', 'responsiveAccordion');
                        $('html, body').scrollTop($target.offset().top - (triggerOffset * 2));
                    }
                }
            } else if (context === 'smallContext') {
                $debug('mobile slide down', 'responsiveAccordion');
                //mobile and not active --- slide down
                $target.slideDown(250, function () {
                    $(this).addClass('MMM--isActive').attr('style', '');
                    if (self.jumpsToTop) {
                        //check this for accuracy
                        $('html, body').scrollTop($target.offset().top - (triggerOffset * 2));
                    }
                });
            } else {
                $debug('desktop', 'responsiveAccordion');
                // calculating offset position of clicked panel (panel numnber is triggerNum) and the scroll position from the accordion container
                $target.addClass('MMM--isActive');
                var targetEndPos = $target.offset().top + $target.height();

                $debug('trigger offset = ' + triggerOffset, 'responsiveAccordion');
                $debug('trigger position = ' + $trigger.scrollTop(), 'responsiveAccordion');
                $debug('target position = ' + $target.scrollTop(), 'responsiveAccordion');

                $debug('current screen position = ' + $('html').scrollTop(), 'responsiveAccordion');
                var jumpToPos = $target.offset().top - (triggerOffset * 2);

                if (self.jumpsToTop) {
                    $debug('JUMPS TO TOP', 'responsiveAccordion');
                    if ($trigger.hasClass('MMM--isActive')) {
                        $debug('    IS ACTIVE', 'responsiveAccordion');
                        $debug('        scrolling to ' + jumpToPos + ' px', 'responsiveAccordion');
                        $('html, body').animate({
                            scrollTop: jumpToPos
                        }, 500);
                    }
                    else {
                        $debug('    IS NOT ACTIVE', 'responsiveAccordion');
                        $('body,html').scrollTop(self.accordionPos);
                    }
                }
            }
        };

        /**
         * Enables the module
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @returns {ResponsiveAccordion}
         * @since 1.0
         */
        ResponsiveAccordion.prototype.enable = function () {
            if (this.isEnabled) {
                return this;
            }

            this.isEnabled = true;

            return this;
        };

        /**
         * Disables the view
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @returns {ResponsiveAccordion}
         * @since 1.0
         */
        ResponsiveAccordion.prototype.disable = function () {
            if (!this.isEnabled) {
                return this;
            }

            this.isEnabled = false;

            // Tear down any event handlers

            return this;
        };
        /*
         * This method creates child objects, or sets up collections.
         * @return {*}
         * @since 1.0
         */
        ResponsiveAccordion.prototype.createChildren = function () {
            var self = this;
            // Creates a jQuery collection of all of the targets, so they can be iterated through.
            this.$triggers.each(function () {
                
                if(!!$(this).attr('eleParent')){
                        var target = $(this).attr('eleParent') +' '+$(this).attr('href');
                } else {
                        var target = $(this).attr('href');
                }
                $debug('target is ' + target, 'responsiveAccordion');
                var $target = $(target);
                self.$targets = self.$targets.add($target);
            });
            return this;
        };
        /**
         * This method to setup the default mini height for target section
         * @return {*}
         * @since 1.0
         */
        ResponsiveAccordion.prototype.setDefaultMiniHeight = function () {
            var self = this,
                defaults = {
                    miniHeight: false
                };

            if(self.$triggers.size() > 0) {
                var option = self.$triggers.eq(0).data().option,
                    setting = $.extend({}, defaults, option);

                //set min height for vtabs
                if(setting.miniHeight) {
                    var triggerAmount = self.$targets.length,
                        firstTriggerTop = self.$triggers.eq(0).position().top,
                        lastTriggerTop = self.$triggers.eq(triggerAmount-1).position().top,
                        gap = lastTriggerTop - firstTriggerTop;

                    var $firstTarget = self.$targets.eq(0),
                        $childFirst = $($firstTarget.children()[0]),
                        firstMiniHeight = parseInt($childFirst.css('min-height'));

                    self.$targets.each(function() {

                        var childContainer = $(this).children()[0];
                         $(childContainer).css('min-height', firstMiniHeight+gap+'px');
                    })
                }

            }

            return this;
        };
        /**
         * Destroys the module
         * Tears down any events, handlers, elements
         * Should be called when the object should be left unused
         *
         * @returns {ResponsiveAccordion}
         * @since 1.0
         */
        ResponsiveAccordion.prototype.destroy = function () {
            this.disable();

            return this;
        };

        return ResponsiveAccordion;
    });

}(MMMRequire));
